import { isDevelopment } from "appConfiguration";
import ContentPasteIcon from "@mui/icons-material/ContentPaste";
import { AppBar, Box, Stack, Toolbar, Tooltip } from "@mui/material";
import Button from "@mui/material/Button";
import { copyTranslationsToClipboard } from "i18n.config";
import type { NextComponentType, NextPageContext } from "next";
import { useRouter } from "next/router";
import type { AvailableRoutes } from "resources/availableRoutes";
import { BrandLogo } from "./BrandLogo";
import { PageErrorBoundary } from "./PageErrorBoundary";
import { PublicLanguageSelect } from "./PublicLanguageSelect";

/**
 * PublicApp is an internal Hub application component that serves as the main
 * entry point for the Public application. Currently used for the public Estimate Request page, and any future public pages.
 */
export function PublicApp({
  Component,
  pageProps,
}: {
  Component: NextComponentType<NextPageContext, any, any>;
  pageProps: any;
}) {
  const { pathname } = useRouter();

  const errorRoute: AvailableRoutes = "/public/error-code";
  if (pathname === errorRoute) {
    return <Component {...pageProps} />;
  }
  return (
    <>
      <AppBar position="sticky" sx={{ mb: 2, pt: 1 }}>
        <Toolbar
          sx={{
            display: "grid",
            gridTemplateColumns: "minmax(0,1fr) 2fr minmax(0,1fr)",
          }}
        >
          <div /> {/* fill slot */}
          <Box width="min(175px, 100%)" justifySelf="center">
            <BrandLogo logoStyle="Mobile" />
          </Box>
          <Stack direction="row" justifySelf="end">
            {isDevelopment && (
              <Tooltip title="Copy translations to clipboard">
                <Button color="inherit" onClick={copyTranslationsToClipboard}>
                  <ContentPasteIcon />
                </Button>
              </Tooltip>
            )}
            <PublicLanguageSelect />
          </Stack>
        </Toolbar>
      </AppBar>
      <PageErrorBoundary>
        <Component {...pageProps} />
      </PageErrorBoundary>
    </>
  );
}
